module.exports = __webpack_public_path__ + "img/paper.4085838e.svg";